import {
    KEYWORDS_DECLINING_FIELDS,
    KEYWORDS_MOVED_UP_FIELDS,
} from "app/pages/activation/components/HomeWithData/ShareData/constants";
import type { KeywordAvgSchema, KeywordTrendsSchema } from "app/pages/activation/types/api";

import type { IRankTrackerWidgetData } from "../TrafficWidgets/types";

import { sumTrendsFields } from "./sumTrendsFields";

export function mapKeywordAvgSchemaToWidgetData(
    schema?: KeywordAvgSchema | null,
    country?: number,
    trends?: KeywordTrendsSchema | null,
): IRankTrackerWidgetData | null {
    if (!schema?.records?.length) {
        return null;
    }
    const first = schema.records[0];

    const keywordsMovedUp = trends ? sumTrendsFields(trends, KEYWORDS_MOVED_UP_FIELDS) : 0;
    const keywordsDeclining = trends ? sumTrendsFields(trends, KEYWORDS_DECLINING_FIELDS) : 0;

    return {
        avgPosition: first.total.avgWeightPosition,
        changeRanksWoW: first.change.avgWeightPosition,
        keywordsMovedUp,
        keywordsDeclining,
        country,
    };
}
